import * as types from "store/projectCreation/projectCreationTypes";

export const createProject = (payload) => ({
  type: types.POST_CREATE_PROJECT,
  payload: payload
});
